import { render, staticRenderFns } from "./SystemStatsPage.vue?vue&type=template&id=20b20a6e"
import script from "./SystemStatsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SystemStatsPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports